import React from 'react';
import DesktopNavClearance from 'components/nav/DesktopHeader/components/DesktopNavClearance';
const desktopStaticNavItems = [{
  id: 'living-room',
  label: 'Living Room',
  longLabel: 'Living Room Furniture',
  url: '/living-room-furniture/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/1-Living-Room/Living-room---Cover.jpg',
  items: [{
    label: 'Sofas + Sectionals',
    id: 'sofas-and-sectionals',
    url: '/sofas-and-sectionals/',
    mobileImage: 'https://joybird2.imgix.net/configurations/pid_9514/-CF200-WS03/9514-CF200-WS03-lewis-sofa-taylor-felt-grey-t1-1_t.png',
    categoryPageLabel: 'Sofas, Sectionals & Loveseats',
    items: [{
      image: 'https://joybird2.imgix.net/configurations/pid_9514/-CF200-WS03/9514-CF200-WS03-lewis-sofa-taylor-felt-grey-t1-1_t.png',
      label: 'Sofas + Loveseats',
      id: 'sofas-and-loveseats',
      url: '/sofas/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_9511/-CF494-WS03/9511-CF494-WS03-lewis-sectional-taylor-felt-gray-t1-1_t.png',
      label: 'Sectionals',
      id: 'sectionals',
      url: '/sectionals/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_8696/-CF033-WS03/8696-CF033-WS03-hughes-sleeper-sofa-bentley-daisey-t1-1_t.png',
      label: 'Sleeper Sofas',
      id: 'sleeper-sofas',
      url: '/sleeper-sofas/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_8153/-CF020/8153-CF020-bryant-ottoman-key-largo-coral-t1-2_t.png',
      label: 'Modular Sofas',
      id: 'modular-sofas',
      url: '/modular-sofas/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_9289/-CF333-WS03/9289-CF333-WS03-chelsea-apartment-sofa-essence-aqua-t1-1_t.png',
      label: 'Apartment Sofas',
      id: 'apartment-sofas',
      url: '/apartment-sofas/'
    }, {
      image: 'https://joybird2.imgix.net/product_hero/13529/Camden-Modular-Reclining-Sofa-(2-piece)-Faithful-Olive-T1-158.jpg',
      label: 'Reclining Sofas',
      id: 'reclining-sofas',
      url: '/reclining-sofas/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_3374/-CF333-WS03/3374-CF333-WS03-anton-daybed-essence-aqua-t1-2_t.png',
      label: 'Chaises + Daybeds',
      id: 'chaises-and-daybeds',
      url: '/daybeds-chaises/'
    }, {
      label: 'Shop All Sofas + Sectionals',
      id: 'shop-all-sofas-and-sectionals',
      url: '/sofas-and-sectionals/',
      hideOnMobile: true
    }]
  }, {
    label: 'Chairs',
    id: 'chairs',
    url: '/chairs/',
    mobileImage: 'https://joybird2.imgix.net/configurations/pid_6653/-CF033-W03/6653-CF033-W03-soto-concave-arm-chair-bentley-daisey-t1-2_t.png',
    items: [{
      image: 'https://joybird2.imgix.net/configurations/pid_6653/-CF033-W03/6653-CF033-W03-soto-concave-arm-chair-bentley-daisey-t1-2_t.png',
      label: 'Apartment Chairs',
      id: 'apartment-chairs',
      url: '/apartment-chairs/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_657/-CF020-W03/657-CF020-W03-soto-chair-key-largo-coral-t1-2_t.png',
      label: 'Accent Chairs',
      id: 'accent-chairs',
      url: '/accent-chairs/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_3289/-CF333-WS03/3289-CF333-WS03-hughes-swivel-chair-essence-aqua-t1-2_t.png',
      label: 'Swivel Chairs',
      id: 'swivel-chairs',
      url: '/swivel-chairs/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_13088/-CF441/13088-CF441-corey-swivel-chair-faithful-olive-t1-2_t.png',
      label: 'Reclining Chairs',
      id: 'reclining-chairs',
      url: '/reclining-chairs/'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_9302/-CL038/9302-CL038-lyle-leather-ottoman-academy-cuero-t1-2_t.png',
      label: 'Ottomans & Benches',
      id: 'ottomans-and-benches',
      url: '/ottomans/'
    }, {
      label: 'Shop All Chairs',
      id: 'shop-all-chairs',
      url: '/chairs/',
      hideOnMobile: true
    }]
  }, {
    label: 'Tables',
    id: 'tables',
    url: '/all-tables/',
    categoryPageLabel: 'Tables and Desks',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9360/9360-hudson-coffee-table-t1-1_ts.png',
    items: [{
      image: 'https://joybird2.imgix.net/product_hero/9360/9360-hudson-coffee-table-t1-1_ts.png',
      label: 'Coffee & End Tables',
      id: 'coffee-and-end-tables',
      url: '/coffee-and-end-tables/'
    }, {
      image: 'https://joybird2.imgix.net/product_hero/10835/hero-juliana-console-table-2.jpg',
      label: 'Console & Entry Tables',
      id: 'console-and-entry-tables',
      url: '/console-and-entry-tables/'
    }, {
      label: 'Shop All Tables',
      id: 'shop-all-tables',
      url: '/all-tables/',
      hideOnMobile: true
    }]
  }, {
    label: 'Storage',
    id: 'storage',
    url: '/all-storage/',
    categoryPageLabel: 'Cabinets and Storage',
    mobileImage: 'https://joybird2.imgix.net/product_hero/895/-W03/895-W03-simic-media-console-t1-1_ts.png',
    items: [{
      image: 'https://joybird2.imgix.net/product_hero/895/-W03/895-W03-simic-media-console-t1-1_ts.png',
      label: 'Storage & Media Consoles',
      id: 'storage-and-media-consoles',
      url: '/media-consoles/'
    }, {
      image: 'https://joybird2.imgix.net/product_hero/9807/9807-lois-bookcase-with-storage-t1-1_ts.png',
      label: 'Bookcases & Shelving',
      id: 'bookcases-and-shelving',
      url: '/bookcases-wall-units/'
    }, {
      image: 'https://joybird2.imgix.net/product_hero/9389/-CF410-WS03/9389-CF410-WS03-briar-sectional-with-storage-royale-cobalt-t1-7_ts.png',
      label: 'Storage Sectionals',
      id: 'storage-sectionals',
      url: '/sofas-and-sectionals/?category=sectionals&features=storage'
    }, {
      image: 'https://joybird2.imgix.net/product_hero/9387/-CF388-WS03/9387-CF388-WS03-hughes-sofa-with-storage-royale-gunmetal-t1-2_ts.png',
      label: 'Storage Sofas',
      id: 'storage-sofas',
      url: '/sofas-and-sectionals/?category=sofas&features=storage'
    }, {
      image: 'https://joybird2.imgix.net/configurations/pid_9528/-CF477-WS03/9528-CF477-WS03-eliot-storage-ottoman-bloke-goldenrod-t1-3_t.png',
      label: 'Storage Ottomans',
      id: 'storage-ottomans',
      url: '/ottomans/?category=ottomans&features=storage'
    }, {
      label: 'Shop All Storage',
      id: 'shop-all-storage',
      url: '/all-storage/',
      hideOnMobile: true
    }]
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/living-room-furniture/?sortBy=newest',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/1-Living-Room/Living-room---New-Arrivals.jpg',
    isNew: true
  }],
  secondaryItems: [{
    label: 'Customer Photos',
    id: 'customer-photos',
    url: '/customer-photos/?room=Living%20Room',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/1-Living-Room/Living-room---Customer-Photos.jpg'
  }],
  ctaLabel: 'Shop All Living Room'
}, {
  id: 'dining-room',
  label: 'Dining Room',
  longLabel: 'Dining Room Furniture',
  url: '/dining-room-furniture/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-Room---Cover.jpg',
  items: [{
    label: 'Dining Tables',
    id: 'dining-tables',
    url: '/dining-tables/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-room---tables.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/dining-tables-1592512539052.png'
  }, {
    label: 'Dining Chairs',
    id: 'dining-chairs',
    url: '/dining-chairs/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-room---Chairs.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/dining-chairs-1592512527100.png'
  }, {
    label: 'Bar Carts + Cabinets',
    id: 'bar-carts-cabinets',
    url: '/bar-carts-cabinets/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-room---Bar-Carts.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9791/9791-piper-cabinet-t1-1_ts.png'
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/dining-room-furniture/?sortBy=newest',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-room---New-Arrivals.jpg',
    isNew: true
  }],
  secondaryItems: [{
    label: 'Customer Photos',
    id: 'customer-photos',
    url: '/customer-photos/?room=Dining%20Room',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/2-Dining-Room/Dining-room---Customer-Photos.jpg'
  }],
  ctaLabel: 'Shop All Dining Room'
}, {
  id: 'bedroom',
  label: 'Bedroom',
  longLabel: 'Bedroom Furniture',
  url: '/bedroom/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---Cover.jpg',
  items: [{
    label: 'Beds',
    id: 'beds',
    url: '/beds/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---Beds.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/4188/-CF200-WS03/4188-CF200-WS03-hughes-bed-taylor-felt-grey-t1-2_ts.png'
  }, {
    label: 'Nightstands',
    id: 'nightstands',
    url: '/nightstands/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---Night-stands.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9380/9380-fenton-nightstand-t1-2_ts.png'
  }, {
    label: 'Dressers + Chests',
    id: 'dressers-and-chests',
    url: '/dressers-chests/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---Dressers.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9381/9381-fenton-dresser-t1-1_ts.png'
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/bedroom/?sortBy=newest',
    isNew: true,
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---New-Arrivals.jpg'
  }],
  secondaryItems: [{
    label: 'Customer Photos',
    id: 'customer-photos',
    url: '/customer-photos/?room=Bedroom',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/3-Bedroom/Bedroom---Customer-Photos.jpg'
  }],
  ctaLabel: 'Shop All Bedroom'
}, {
  id: 'home-office',
  label: 'Home Office',
  longLabel: 'Home Office Furniture',
  url: '/home-office-furniture/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---Cover.jpg',
  items: [{
    label: 'Desks',
    id: 'desks',
    url: '/desks/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---Desks.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/office-desks@2x-1587760453135.png'
  }, {
    label: 'Bookcases',
    id: 'bookcases',
    url: '/bookcases-wall-units/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---Book-Cases.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/office-bookcases@2x-1587760409705.png'
  }, {
    label: 'Office Chairs',
    id: 'office-chairs',
    url: '/office-chairs/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---Office-Chairs.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/10882/-hrbrntrl/10882-hrbrntrl-corbyn-office-chair-t1-1_ts.png'
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/home-office-furniture/?sortBy=newest',
    isNew: true,
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---New-Arrivals.jpg'
  }],
  secondaryItems: [{
    label: 'Customer Photos',
    id: 'customer-photos',
    url: '/customer-photos/?room=Home%20Office',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/4-Home-Office/Home-Office---Customer-Photos.jpg'
  }],
  ctaLabel: 'Shop All Home Office'
}, {
  id: 'outdoor',
  label: 'Outdoor',
  longLabel: 'Outdoor Furniture',
  url: '/outdoor-furniture/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---cover.jpg',
  items: [{
    label: 'Outdoor Sofas',
    id: 'outdoor-sofas',
    url: '/outdoor-sofas/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---sofas.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/outdoor-sofas-1588272484868.png'
  }, {
    label: 'Outdoor Chairs',
    id: 'outdoor-chairs',
    url: '/outdoor-chairs/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---chairs.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/outdoor-chairs-1588272510614.png'
  }, {
    label: 'Outdoor Tables',
    id: 'outdoor-tables',
    url: '/outdoor-tables/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---tables.jpg',
    mobileImage: 'https://joybird2.imgix.net/user-uploads-staging/outdoor-tables-1588272548375.png'
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---new-arrivals.jpg',
    url: '/outdoor-furniture/?sortBy=newest',
    isNew: true
  }],
  secondaryItems: [{
    label: 'Outdoor Lookbook',
    id: 'outdoor-lookbook',
    image: 'https://joybird2.imgix.net/user-uploads-staging/webimage-15879640-1EC8-431B-BA61E52E1D3D2FA3.jpg',
    description: 'Shop our outdoor lookbook',
    descriptionTextColor: 'light',
    url: '/lookbooks/outdoor-2024'
  }, {
    label: 'Customer Photos',
    id: 'customer-photos',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/5-Outdoor/outdoor---custoemr-photos.jpg',
    url: '/customer-photos/?room=Outdoor%20Room'
  }],
  ctaLabel: 'Shop All Outdoor'
}, {
  id: 'decor',
  label: 'Decor',
  longLabel: 'Decor + Accessories',
  categoryPageLabel: 'Decoration Accessories',
  url: '/decoration-accessories/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/6-Decor/Decor---Cover.jpg',
  items: [{
    label: 'Pillows',
    id: 'pillows',
    url: '/pillows/',
    image: 'https://joybird2.imgix.net/product_hero/8269/Camilla_bed_sunbrella_p_wisteria-1120-0015.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/5602/-CF200/5602-CF200-decorative-knife-edge-pillows-18-x-18-(set-of-2)-taylor-felt-grey-t1-1_ts.png'
  }, {
    label: 'Throws',
    id: 'throws',
    url: '/throws/',
    image: 'https://joybird2.imgix.net/product_hero/11272/Mindi-Throw-01.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/10732/10732-mira-throw-t1-1_ts.png'
  }, {
    label: 'Rugs',
    id: 'rugs',
    url: '/rugs/',
    image: 'https://joybird2.imgix.net/product_hero/9599/Lewis-sofa_1_Final.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9224/9224-aina-rug-t1-1_ts.png'
  }, {
    label: 'Poufs & Cubes',
    id: 'poufs-and-cubes',
    url: '/poufs/',
    image: 'https://joybird2.imgix.net/product_hero/10408/Buy-More-Save-More-Del-Mar-Ottoman-T4-2-1b.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/9302/-CL038/9302-CL038-lyle-leather-ottoman-academy-cuero-t1-2_ts.png'
  }, {
    label: 'Pet Beds',
    id: 'pet-beds',
    url: '/pet-beds/',
    image: 'https://joybird2.imgix.net/product_hero/11004/Dog-Bed-Royale-Evergreen-11-x.jpg',
    mobileImage: 'https://joybird2.imgix.net/public_img/pet-bed.png'
  }, {
    label: 'Lighting',
    id: 'lighting',
    url: '/all-lighting/',
    image: 'https://joybird2.imgix.net/product_hero/3369/Camille-Bed-Royale-Blush-T2-109.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/11096/Sophi-Table-Lamp-T1-1.png'
  }, {
    label: 'Wall Decor',
    id: 'wall-decor',
    url: '/wall-decor/',
    image: 'https://joybird2.imgix.net/product_hero/10881/Collins_Chair_Nico_Oyster_0712.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/10881/coll-Wall-Art-T1-052.jpg'
  }, {
    label: 'Wallpaper',
    id: 'wallpaper',
    url: '/wallpaper/',
    image: 'https://joybird2.imgix.net/product_hero/11125/SF648-ScandiFloral-Teal-Kitchen.jpg',
    mobileImage: 'https://joybird2.imgix.net/public_img/wallpaper.png'
  }, {
    label: 'Mirrors',
    id: 'mirrors',
    url: '/mirrors/',
    image: 'https://joybird2.imgix.net/product_hero/10932/Camilla_bed_sunbrella_p_wisteria-1120-0145.jpg',
    mobileImage: 'https://joybird2.imgix.net/product_hero/10390/10390-frances-mirror-t1-1_ts.png'
  }, {
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/decoration-accessories/?sortBy=newest',
    image: 'https://joybird2.imgix.net/user-uploads-staging/decor.jpg',
    isNew: true
  }],
  ctaLabel: 'Shop All Decor'
}, {
  id: 'featured',
  label: 'Featured',
  url: '/featured',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---cover.jpg',
  items: [{
    label: 'New Arrivals',
    id: 'new-arrivals',
    url: '/new-arrivals/?sortBy=newest',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---new-arrivals.jpg'
  }, {
    label: 'Ready to Ship',
    id: 'quick-ship',
    url: '/instock/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---Ready-to-ship.jpg'
  },
  // {
  //   label: 'Fabric of the Month',
  //   id: 'fabric-of-the-month',
  //   url: '/fabric-of-the-month/',
  //   image:
  //     'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---FOTM.jpg',
  // },
  {
    label: 'Joybird x Pantone',
    id: 'pantone',
    url: '/collaborations/pantone/',
    image: 'https://joybird2.imgix.net/public_img/Simon-Nav-Menu-Image.jpg'
  }, {
    label: 'Recliner Collection',
    id: 'recliner-collection',
    url: '/recliner-collection/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---recliner-collection.jpg'
  }, {
    label: 'Small Spaces',
    id: 'small-spaces',
    url: '/small-spaces/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---Small-spaces.jpg'
  }, {
    label: 'Partnerships & Collaborations',
    id: 'collaborations',
    url: '/collaborations/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---partnerships.jpg'
  }, {
    label: 'Latest Lookbook',
    id: 'latest-lookbook',
    url: '/lookbooks/fall-2024/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/7-Featured/Featuered---latest-lookbook.jpg'
  }]
}, {
  id: 'sale',
  label: 'Sale',
  url: '/sale/',
  color: 'red',
  image: 'https://jbimages.imgix.net/Category-Thumb2-Sale-396e35b6-986c-48a3-abf2-a92d6884fc94.jpg',
  items: [{
    label: 'Clearance',
    id: 'clearance',
    url: '/clearance/',
    customContent: <DesktopNavClearance />
  }],
  ctaLabel: 'Shop All Sale',
  ctaUrl: '/sale/'
}, {
  id: 'inspiration',
  label: 'Inspiration',
  url: '/customer-photos/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---cover.jpg',
  items: [{
    label: 'Customer Photos',
    id: 'customer-photos',
    url: '/customer-photos/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---Customer-photos.jpg'
  }, {
    label: 'Fabric Swatches',
    id: 'fabric-swatches',
    url: '/swatches/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---fabric-swatches.jpg'
  }, {
    label: 'Collections',
    id: 'collections',
    url: '/collections/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---collections.jpg'
  }, {
    label: 'Lookbooks',
    id: 'lookbooks',
    url: '/lookbooks/',
    descriptionTextColor: 'light',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---lookbooks.jpg'
  }, {
    label: 'Blog',
    id: 'blog',
    url: '/blog/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/8-Inspiration/inspiration---blog.jpg'
  }
  // "Joybird Picks" item is commented out until updates to Custom List
  // Configuration type are complete:
  // https://stitchindustries.atlassian.net/browse/CON-3615
  // {
  //   label: 'Joybird Picks',
  //   id: 'joybird-picks',
  //   url: '/joybirds-picks/',
  //   image:
  //     'https://joybird2.imgix.net/product_hero/9167/5-Ways-to-Create-a-Cozy-Bedroom-Shelby-Bed-T3-Uncropped-161-flipped1.jpg',
  //   items: [
  //     {
  //       label: 'Light & Lively',
  //       id: 'light-and-lively',
  //       url: '/joybirds-picks/light-and-lively/',
  //     },
  //     {
  //       label: 'Warm & Inviting',
  //       id: 'warm-and-inviting',
  //       url: '/joybirds-picks/warm-and-inviting/',
  //     },
  //     {
  //       label: 'Seasonal Selections',
  //       id: 'seasonal-selections',
  //       url: '/joybirds-picks/memorial-day-picks/',
  //     },
  //   ],
  // },
  ],
  ctaLabel: 'Shop All Inspiration'
}, {
  id: 'free-design-services',
  label: 'Free Design Services',
  url: '/free-design-services/',
  image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/9-Design-Services/Design-Services---cover.jpg',
  items: [{
    label: '3D Space Planner',
    id: 'three-d-space-planner',
    url: 'https://design.joybird.com/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/9-Design-Services/Design-Services---space-planner.jpg'
  }, {
    label: '3D Room Scanner',
    id: 'three-d-room-scanner',
    url: 'https://design.joybird.com/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/9-Design-Services/Design-Services---room-scanner.jpg'
  }, {
    label: 'Modular Sofa Builder',
    id: 'three-d-sofa-builder',
    url: '/modular-sofas/',
    image: 'https://joybird2.imgix.net/public_img/product_hero/navbar/9-Design-Services/Design-Services---modular-builder.jpg'
  }],
  ctaLabel: 'Joybird Design House'
}];
export default desktopStaticNavItems;